import axios from "axios";
import authHeader from "../auth-header";

const API_URL = process.env.REACT_APP_API_URL + "api/utiluser-management/";

class UserService {
  async getRoles(userBaseModel) {
    return axios.post(API_URL + "roles", userBaseModel, {
      headers: await authHeader(),
    });
  }

  async getUsers() {
    return axios.get(API_URL + "users", { headers: await authHeader() });
  }

  async updateUser(userModel) {
    return axios.patch(API_URL + "user/" + userModel.id, userModel, {
      headers: await authHeader(),
    });
  }
}

const userService = new UserService();
export default userService;
